module.exports = __webpack_public_path__ + "static/media/S3N6-6.177791f0.svg";